<template>
    <div class="InterRichText">
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
            <div class="InterRichText-menubar">

                <button class="InterRichText-menubar-button"
                        :class="{ 'is-active': isActive.bold() }"
                        @click="commands.bold"
                >
                    <strong>B</strong>
                </button>

                <button
                        class="InterRichText-menubar-button"
                        :class="{ 'is-active': isActive.italic() }"
                        @click="commands.italic"
                >
                    <em>I</em>
                </button>

                <button
                        class="InterRichText-menubar-button text-"
                        :class="{ 'is-active': isActive.underline() }"
                        @click="commands.underline"
                >
                    <u>U</u>
                </button>

                <button
                        class="InterRichText-menubar-button ml-3"
                        :class="{ 'is-active': isActive.paragraph() }"
                        @click="commands.paragraph"
                >
                    P
                </button>

                <button
                        class="InterRichText-menubar-button ml-3"
                        :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                        @click="commands.heading({ level: 1 })"
                >
                    H1
                </button>

                <button
                        class="InterRichText-menubar-button"
                        :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                        @click="commands.heading({ level: 2 })"
                >
                    H2
                </button>

                <button
                        class="InterRichText-menubar-button"
                        :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                        @click="commands.heading({ level: 3 })"
                >
                    H3
                </button>

                <button
                        class="InterRichText-menubar-button ml-3"
                        :class="{ 'is-active': isActive.bullet_list() }"
                        @click="commands.bullet_list"
                >
                    UL
                </button>

                <button
                        class="InterRichText-menubar-button ml-auto"
                        @click="commands.undo"
                >
                    UNDO
                </button>

                <button
                        class="InterRichText-menubar-button"
                        @click="commands.redo"
                >
                    REDO
                </button>

            </div>
        </editor-menu-bar>
        <editor-content :editor="editor" class="InterRichText-editor-content"/>
    </div>
</template>

<script>
    import {Editor, EditorContent, EditorMenuBar} from 'tiptap'
    import {
        HardBreak,
        Heading,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Italic,
        Link,
        Underline,
        History,
    } from 'tiptap-extensions'

    export default {
        name: "InterRichText",
        components: {
            EditorContent,
            EditorMenuBar
        },
        data() {
            return {
                editor: new Editor({
                    content: '',
                    extensions: [
                        new BulletList(),
                        new HardBreak(),
                        new Heading({levels: [1, 2, 3]}),
                        new ListItem(),
                        new TodoItem(),
                        new TodoList(),
                        new Link(),
                        new Bold(),
                        new Italic(),
                        new Underline(),
                        new History(),
                    ]
                })
            }
        },
        mounted() {
            this.editor.on('update', () => {
                this.$emit('onEditorUpdate', this.editor.getHTML());
            })
        },
        beforeDestroy() {
            this.editor.destroy()
        }
        ,
    }
</script>

<style scoped>

</style>
